import React from 'react'
import { Spinner, Col, Row, Button } from 'react-bootstrap'

interface ButtonProps {
  isDisabled: boolean
}

const AddButtonGroup = ({ isDisabled }: ButtonProps) => {
  return (
    <>
      <Col xs={5} sm={6} lg={2} className="pt-5 mx-auto">
        <Row>
          <Button
            variant="primary"
            disabled={isDisabled}
            data-testid="add-submit"
            type="submit"
          >
            {isDisabled ? (
              <>
                <h5>
                  <Spinner animation="border" size="sm" /> Add gift
                </h5>
              </>
            ) : (
              <h5>Add gift</h5>
            )}
          </Button>
        </Row>
      </Col>
    </>
  )
}

export default AddButtonGroup
